
import React from 'react';
import {columns} from "./columns";
import { getData } from '../../requests/CRUD';
import { TEAM } from '../../consts/tables';

import {Link} from "react-router";
import { HSC_AGENTS_COUNT, HSC_INVESTORS_COUNT, HSC_PROPERTIES_COUNT, HSC_LENDER_COUNT, HSC_COURTING_COUNT,HSC_FOLLOW_UP_COUNT } from '../Graphql/Queries/HscHotlistQuery';
import { fetchData } from '../Service/graphQlService';
import { GetOldResponse } from '../ResponseConversion/GetOldResponse';
import { GET_CONTACT_TEAM_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';

export default class HscHotlist extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rows: {},
            query:{},
            loading: false,
            isPrint: false,
            printBackground: '',
            hscAgentsData:[]
        };

        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
    }


    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }
    
    componentDidMount(){        
        Promise.all([
            fetchData(GET_CONTACT_TEAM_LIST_QUERY, {type:"Team",filters: [{is_agent: 'h'}], sortOptions:[]})            
        ]).then((res) => {
            const hscAgentsData = res[0].data.getContacts.data.reduce((acc, currentValue) => {
                if (
                  currentValue.email &&
                  ["highstcapital", "athenacapitalre.com"].some((domain) =>
                    currentValue.email.toLowerCase().includes(domain),
                  )
                ) {
                  const formattedData = {
                    agent_id: currentValue.arcimedes_row_id,
                    agent_name: `${currentValue.first_name} ${currentValue.last_name}`,
                    email: currentValue.email,
                    hsc_properties_count: 0,
                    hsc_agents_count: 0,
                    hsc_investors_count: 0,
                    hsc_lender_count: 0,
                    hsc_followup_count: 0,
                    hsc_courting_count: 0,
                  };
                  acc.push(formattedData);
                }
                return acc;
            }, [])
            this.setState({ hscAgentsData })
            hscAgentsData && Array.isArray(hscAgentsData) && hscAgentsData.length &&
            hscAgentsData.forEach((item) => {
                const { email, agent_id } = item;
                const { hscAgentsData } = this.state;
                Promise.all([                        
                    fetchData(HSC_PROPERTIES_COUNT,  { hscMemberMailId: email }),
                    fetchData(HSC_AGENTS_COUNT, { hscMemberMailId: email }),
                    fetchData(HSC_INVESTORS_COUNT, { hscMemberMailId: email }),
                    fetchData(HSC_LENDER_COUNT, { hscMemberMailId: email }),
                    fetchData(HSC_FOLLOW_UP_COUNT, {hscMemberMailId: email  }),
                    fetchData(HSC_COURTING_COUNT, { hscMemberMailId: email })
                ]).then(res => {
                    const hscFollowUpRes = res[0].data.hscHotlistPropertiesCount;//GetOldResponse(res[0].data.hscPropertiesFollowUpCount);
                    const hscAgentsCountRes = res[1].data.hscAgentsCount;//GetOldResponse(res[1].data.hscAgentsCount);
                    const hscInvestorsCountRes = res[2].data.hscInvestorsCount;//GetOldResponse(res[2].data.hscBuyersCount);
                    const hscLendersCountRes = res[3].data.hscLendersCount;
                    const hscFollowupCountRes = res[4].data.hscFollowupCount;
                    const hscCourtingCountRes = res[5].data.hscCourtingCount;
                    // Update the data with the results from both queries by using shallow copies of local state data
                    const hscAgentsDataCopy = [...hscAgentsData];
                    // finding the hsc agent index postion using email 
                    const index = hscAgentsData.findIndex((data) => data.email === email);
                    if (index !== -1) {
                        hscAgentsDataCopy[index].hsc_properties_count = hscFollowUpRes && hscFollowUpRes.data && hscFollowUpRes.data.hsc_properties_count ? parseInt(hscFollowUpRes.data.hsc_properties_count, 10):0;
                        hscAgentsDataCopy[index].hsc_agents_count = hscAgentsCountRes && hscAgentsCountRes.data && hscAgentsCountRes.data.hsc_agents_count ? parseInt(hscAgentsCountRes.data.hsc_agents_count, 10):0;
                        hscAgentsDataCopy[index].hsc_investors_count = hscInvestorsCountRes && hscInvestorsCountRes.data && hscInvestorsCountRes.data.hsc_investors_count ? parseInt(hscInvestorsCountRes.data.hsc_investors_count, 10) : 0;
                        hscAgentsDataCopy[index].hsc_lender_count = hscLendersCountRes && hscLendersCountRes.data && hscLendersCountRes.data.hsc_lender_count ? parseInt(hscLendersCountRes.data.hsc_lender_count, 10) : 0;
                        hscAgentsDataCopy[index].hsc_courting_count = hscCourtingCountRes && hscCourtingCountRes.data && hscCourtingCountRes.data.hsc_courting_count ? parseInt(hscCourtingCountRes.data.hsc_courting_count, 10) : 0;
                        hscAgentsDataCopy[index].hsc_followup_count = hscFollowupCountRes && hscFollowupCountRes.data && hscFollowupCountRes.data.hsc_followup_count ? parseInt(hscFollowupCountRes.data.hsc_followup_count, 10) : 0;
                        this.setState({ hscAgentsData: hscAgentsDataCopy });
                    }                     
                });
            })

        })

    }



    renderTable(columns, rows) {
        const flatColumns = columns.flatMap(col => col.subColumns || [col]);

        return (
            <table>
            <thead>
                <tr>
                {columns.map((col, index) => {
                    if (col.subColumns) {
                    return (
                        <th key={index} colSpan={col.subColumns.length} className="Pipeline_th">
                        {col.name}
                        </th>
                    );
                    } else {
                    return (
                        <th key={index} rowSpan="2" className="Pipeline_th">
                        {col.name}
                        </th>
                    );
                    }
                })}
                </tr>
                <tr>
                {columns.map((col, index) =>
                    col.subColumns
                    ? col.subColumns.map((subCol, subIndex) => (
                        <th key={`${index}-${subIndex}`} className={`Pipeline_th ${subCol.class || ''}`}>
                            {subCol.name}
                        </th>
                        ))
                    : null
                )}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, rowIndex) => (
                    <tr key={row.agent_id || rowIndex}>
                    {flatColumns.map((col, colIndex) => {
                        const cellValue = row[col.key];

                        // Custom render for AGENT_NAME
                        if (col.key === 'agent_name') {
                        return (
                            <td key={colIndex} className={col.class || ''}>
                            <Link
                                to={{
                                pathname: `${arc.path.base}hsc-hotlist/${row.agent_id}/${row.email}`,
                                state: { id: row.agent_id, name: row.agent_name },
                                }}
                            >
                                {row.agent_name}
                            </Link>
                            </td>
                        );
                        }

                        return (
                        <td key={colIndex} className={col.class || ''}>
                            {cellValue !== undefined ? cellValue : '-'}
                        </td>
                        );
                    })}
                    </tr>
                ))}
                </tbody>
            </table>
        );
    
       /*  return (
            <table>
                <thead>
                <tr>
                    {
                        columns.map((column, index) => 
                            <th key={index} className="Pipeline_th">{column.name}</th>
                        )
                    }
                </tr>
                </thead>
                <tbody>
                    {
                        rows.map(value => 
                            <tr key={value.AGENT_ID}>
                                <td className='Pipeline_td'>
                                    <Link to={{pathname: `${arc.path.base}hsc-hotlist/${value.agent_id}/${value.email}`, state: {id: value.agent_id, name: value.agent_name}}}>{value.agent_name}</Link>
                                 </td>
                                <td className='Pipeline_column_numeric'>
                                    {value.hsc_properties_count}                                    
                                </td>
                                <td className='Pipeline_column_numeric'>
                                    {value.hsc_agents_count}                                    
                                </td>
                                <td className='Pipeline_column_numeric'>
                                    {value.hsc_investors_count}                                                       
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        ); */
    }

    render(){
        const {rows, loading, isPrint, printBackground, query,hscAgentsData} = this.state;
        const d = new Date();
        const date = d.getMonth()+1+'/'+d.getDate()+'/'+d.getFullYear();

        return (
            <div className='Pipeline'>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    <div className='Pipeline_head'>
                        <div className="Pipeline_head_left">
                            <h3 className='Pipeline_h3'>AthCap - Hot List</h3>
                            <h4 className='Pipeline_h4'>{date}</h4>
                        </div>
                        <div className='Pipeline_head_right'>
                            {""}
                        </div>
                    </div>
                    {
                        loading ?
                            <div className='loading'>Loading data...</div>
                            :
                            this.renderTable(columns, hscAgentsData)
                    }
                </div>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
            </div>
        )
    }
   
}
